export const trackerPageText = {
  ru: {
    description: 'Отслеживайте изменения статуса закупок и появление протокола обсуждения в Telegram.',
    loading: 'Загрузка отслеживаемых закупок…', refresh: 'Обновить', retry: 'Повторить',
    clearSearch: 'Очистить поиск', close: 'Закрыть', details: 'Открыть закупку',
    unavailable: 'Данные закупки пока недоступны', unknown: 'Нет данных',
    published: 'Опубликован', notPublished: 'Не опубликован',
    portal: 'Открыть на Госзакупе', amount: 'Сумма закупки', customer: 'Заказчик по лоту',
    applications: 'Приём заявок', start: 'Начало', end: 'Окончание',
    discussion: 'Обсуждение документации', noDiscussion: 'Даты обсуждения не указаны',
    lots: 'Прикреплённые лоты', lot: 'Лот', lastChecked: 'Последняя проверка',
    balance: 'Доступно добавлений', billing: 'Пополнить', searchLots: 'Перейти к поиску лотов',
    deleted: 'Отслеживание остановлено', active: 'Отслеживается', completed: 'Завершено', failed: 'Ошибка',
    deleteNote: 'Использованный слот не возвращается. Повторное добавление потребует ещё один слот.',
    telegramMissing: 'Telegram не привязан. Привяжите его в профиле, чтобы получать уведомления.',
    profile: 'Привязать Telegram', dateUnknown: 'Дата не указана',
    statusChange: 'Изменение статуса', protocolPublished: 'Опубликован протокол обсуждения',
    deliveryPending: 'Уведомление ожидает отправки',
    deliveryUncertain: 'Доставка требует проверки. Повторная отправка приостановлена, чтобы избежать дублей.',
  },
  kk: {
    description: 'Сатып алу мәртебесінің өзгерістерін және талқылау хаттамасының жариялануын Telegram арқылы қадағалаңыз.',
    loading: 'Қадағаланатын сатып алулар жүктелуде…', refresh: 'Жаңарту', retry: 'Қайталау',
    clearSearch: 'Іздеуді тазарту', close: 'Жабу', details: 'Сатып алуды ашу',
    unavailable: 'Сатып алу деректері әзірге қолжетімсіз', unknown: 'Деректер жоқ',
    published: 'Жарияланды', notPublished: 'Жарияланбады',
    portal: 'Мемлекеттік сатып алу порталында ашу', amount: 'Сатып алу сомасы', customer: 'Лот тапсырыс берушісі',
    applications: 'Өтінімдерді қабылдау', start: 'Басталуы', end: 'Аяқталуы',
    discussion: 'Құжаттаманы талқылау', noDiscussion: 'Талқылау күндері көрсетілмеген',
    lots: 'Қосылған лоттар', lot: 'Лот', lastChecked: 'Соңғы тексеру',
    balance: 'Қолжетімді қосулар', billing: 'Толықтыру', searchLots: 'Лоттарды іздеуге өту',
    deleted: 'Қадағалау тоқтатылды', active: 'Қадағалануда', completed: 'Аяқталды', failed: 'Қате',
    deleteNote: 'Пайдаланылған слот қайтарылмайды. Қайта қосу үшін тағы бір слот қажет.',
    telegramMissing: 'Telegram байланыстырылмаған. Хабарламалар алу үшін оны профильде байланыстырыңыз.',
    profile: 'Telegram байланыстыру', dateUnknown: 'Күні көрсетілмеген',
    statusChange: 'Мәртебе өзгерді', protocolPublished: 'Талқылау хаттамасы жарияланды',
    deliveryPending: 'Хабарлама жіберілуді күтуде',
    deliveryUncertain: 'Жеткізуді тексеру қажет. Қайталама хабарламаларды болдырмау үшін қайта жіберу тоқтатылды.',
  },
} as const;
